import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "#357DED",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.9976 21.5012L-0.00292969 12.4986L2.99654 9.49911L8.9976 15.498L20.9955 3.49805L23.9971 6.49964L8.9976 21.5012Z" })
});
export default SvgTick;
